var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gop-notification-container",
      attrs: { "aria-live": "polite", "aria-relevant": "additions removals" }
    },
    [
      _c(
        "transition-group",
        {
          staticClass: "notification-list",
          attrs: { name: "notification", tag: "div" }
        },
        _vm._l(_vm.notifications, function(notification) {
          return _c(
            "div",
            {
              key: notification.id,
              staticClass: "notification",
              class: `notification--${notification.type}`,
              attrs: { role: "status" },
              on: {
                mouseenter: function($event) {
                  return _vm.pause(notification.id)
                },
                mouseleave: function($event) {
                  return _vm.resume(notification.id)
                }
              }
            },
            [
              _c("div", { staticClass: "notification__content" }, [
                _c(
                  "div",
                  {
                    staticClass: "notification__icon",
                    attrs: { "aria-hidden": "true" }
                  },
                  [
                    notification.type === "success"
                      ? _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                          _c("path", {
                            attrs: {
                              d: "M20 6L9 17l-5-5",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }
                          })
                        ])
                      : notification.type === "error"
                      ? _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                          _c("path", {
                            attrs: {
                              d: "M7 7l10 10M17 7L7 17",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round"
                            }
                          })
                        ])
                      : notification.type === "warning"
                      ? _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                          _c("path", {
                            attrs: {
                              d: "M12 8v5M12 17h.01",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round"
                            }
                          })
                        ])
                      : _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                          _c("path", {
                            attrs: {
                              d: "M12 11v6M12 7h.01",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round"
                            }
                          })
                        ])
                  ]
                ),
                _c("div", { staticClass: "notification__message" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(notification.message)
                          ? _vm.$t(notification.message)
                          : notification.message
                      ) +
                      " "
                  )
                ]),
                _c(
                  "button",
                  {
                    staticClass: "notification__close",
                    attrs: {
                      type: "button",
                      "aria-label": "Close notification"
                    },
                    on: {
                      click: function($event) {
                        return _vm.close(notification.id)
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: { viewBox: "0 0 24 24", "aria-hidden": "true" }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M6 6l12 12M18 6L6 18",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]),
              notification.duration > 0
                ? _c("div", {
                    staticClass: "notification__lifetime",
                    style: { height: `${notification.progress}%` },
                    attrs: { "aria-hidden": "true" }
                  })
                : _vm._e()
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }